<template>
  <div class="grid">
    <div class="page-index">
      <div class="main">
        <div class="page_first index_news_dowload_page_bag">
          <div class="videoBg">
            <div class="videoHere">
              <video loop="" preload="none" muted="" data-autoplay="" autoplay="autoplay" playsinline webkit-playsinline :src="homeVideo"></video>
              <div class="hbt_div" v-if="false">
                <div class="hbt_play">
                  <img @click="yyvideoOpen" src="@/assets/images/index/index_header_bth_play.png" alt="播放按钮" />
                </div>
                <!-- <div class="hbt_text"> 燃擎公测 等你来战</div> -->
                <!-- :class="isWhitchBtn == 0 ? 'noneImg' : isWhitchBtn == 1 ? 'goYuyue' : isWhitchBtn == 2 ? 'getReceCode' : 'alerayReceCode'" -->
                <!-- <div class="hbt_btn goYuyue" @click="appointment(isWhitchBtn)">
                </div> -->
              </div>
              <!-- <div class="slogin_title"></div> -->
            </div>
          </div>
          <div class="pfBottomImg"></div>
        </div>
        <div class="page_second">
          <div class="cadpa" @click="cadpaClick">
            <img src="@/assets/images/index/cadpa.png" alt="适龄提示" />
          </div>
          <div class="psBox main_width">
            <div class="swiperAndNews">
              <div class="left_san">
                <a class="ls_a" target="_blank" href="download.html" title="下载游戏">
                  <img class="ps_down_img" src="@/assets/images/index/ps_down.png" alt="下载游戏" />
                  <img class="ps_down_img_text anima" src="@/assets/images/index/ps_down_text.png" alt="下载游戏" />
                </a>
                <a class="ls_a" href="javascript:void(0);" title="账号注册" @click="registerItem" target="_self">
                  <img src="@/assets/images/index/ps_reg.png" alt="账号注册" />
                </a>
                <a class="ls_a" href="activation.html" title="账号激活" target="_blank">
                  <img src="@/assets/images/index/ps_account.png" alt="账号激活" />
                </a>
                <div class="four_ls_a">
                  <a class="ls_a" target="_blank" v-for="(vdt, vdi) in lsBtnDownList" :key="vdi" :href="vdt.url" :title="vdt.title">
                    <img :src="vdt.img" :alt="vdt.title" />
                  </a>
                </div>
              </div>
              <div class="right_san">
                <div class="swiperBox">
                  <swiper ref="actSwiper" :options="swiperActOptions">
                    <swiper-slide v-for="(item, key) in activityBannerList" :key="key">
                      <a :href="item.bannerUrl" target="_blank">
                        <img :src="item.bannerImage" class="banner" :alt="item.bannerName" />
                      </a>
                    </swiper-slide>
                    <div class="swiper-paginate" slot="pagination"></div>
                  </swiper>
                </div>
                <div class="newsBox" v-loading="newsLoading" element-loading-text="内容加载中 …" element-loading-background="rgba(0, 0, 0, 0.5)">
                  <!-- tab -->
                  <ul class="tabUl">
                    <li v-for="(navItem, navIndex) in newsTabList" :key="navIndex" :class="{ isTabActive: isIndex == navIndex }" @click="tabClick(navItem, navIndex)">
                      {{ navItem.label }}
                    </li>
                    <li class="moreNews">
                      <a title="查看更多" target="_blank" :href="newsId != null ? 'news.html?newsId=' + newsId + '&publishTerrace=' + 1 : 'news.html'">
                        <img src="@/assets/images/index/all_news.png" alt="查看更多" />
                      </a>
                    </li>
                  </ul>
                  <ul class="contentUl">
                    <div>
                      <li class="isTopLiData" v-for="(citem_top, cindex_top) in isTopOneArr" :key="cindex_top">
                        <a target="_blank" :href="citem_top.isOutLink != 0 ? 'news_details.html?newsId=' + citem_top.id : citem_top.skipUrl">{{ citem_top.title }}</a>
                      </li>
                    </div>
                    <!-- 颜色 :class="{ imporInfo: citem.type == 1 }" -->
                    <li v-for="(citem, cindex) in zeroTopOneArr" :key="cindex">
                      <a target="_blank" :href="citem.isOutLink != 0 ? 'news_details.html?newsId=' + citem.id : citem.skipUrl">
                        <span>
                          <!-- <b v-text="
                            newsId == 0
                              ? '【公告】'
                              : newsId == 1
                                ? '【新闻】'
                                : newsId == 2
                                  ? '【活动】'
                                  : '【综合】'
                          "></b> -->
                          <b v-text="citem.type == 0 ? '【公告】' : citem.type == 1 ? '【新闻】' : citem.type == 2 ? '【活动】' : ''"></b>
                          {{ citem.title }}</span
                        >
                        <span class="news_time">{{ timeFormat(parseTime(citem.publishTime)).substring(timeFormat(parseTime(citem.publishTime)).indexOf('-') + 1, timeFormat(parseTime(citem.publishTime)).length) }}</span>
                        <span class="news_hover_img">
                          <img src="@/assets/images/index/news_a_jt.png" alt="新闻箭头" />
                        </span>
                      </a>
                      <div class="clear"></div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <ul class="threeInfo">
              <li v-for="(tht, thi) in thList" :key="thi">
                <a :href="tht.url" target="_blank">
                  <p>{{ tht.text1 }}</p>
                  <p>{{ tht.text2 }}</p>
                  <p>立即查看</p>
                  <img :src="tht.img" :alt="tht.text1" />
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="page_last">
          <div class="plBox main_width">
            <div class="videoPage">
              <div class="video_center">
                <div class="infoTitle vc_tab">
                  <img src="@/assets/images/index/video_cente_title.png" alt="视频中心" />
                  <div class="info_title_line"></div>
                  <ul class="vc_tab_ul">
                    <li v-for="(vtt, vti) in vibTab" :key="vti" :class="{ va_tab_a: vti == vtcur }" @click="vtTabClick(vti)">{{ vtt.name }}</li>
                    <div class="act_line"></div>
                    <li class="last_go_more">
                      <a :href="'video_page.html?videoId=' + vtcur">MORE <b>+</b> </a>
                    </li>
                  </ul>
                </div>
                <ul class="video_box">
                  <li v-for="(viItem, viIndex) in vibList" :key="viIndex">
                    <div class="paster_box">
                      <img :src="viItem.cover" :alt="viItem.desc" />
                      <div class="video_mask" @click="viDetails(viItem)">
                        <div class="play_btn">
                          <img src="@/assets/images/index/index_header_bth_play.png" alt="播放按钮" />
                        </div>
                      </div>
                    </div>
                    <div class="paster_text">
                      <p>{{ viItem.desc }}</p>
                      <p>{{ timeFormat(parseTime(viItem.release_time)).substring(timeFormat(parseTime(viItem.release_time)).indexOf('-') + 1, timeFormat(parseTime(viItem.release_time)).length) }}</p>
                    </div>
                  </li>
                </ul>
              </div>
              <div class="video_live">
                <div class="infoTitle">
                  <img src="@/assets/images/index/video_live_title.png" alt="精彩直播" />
                  <div class="info_title_line"></div>
                </div>
                <ul class="live_box">
                  <li v-for="(lvItem, lvIndex) in lvList" :key="lvIndex" @click="lvClick(lvItem)">
                    <div class="paster_box">
                      <img :src="lvItem.img" :alt="lvItem.text" />
                    </div>
                    <div class="paster_text">
                      <p>{{ lvItem.text }}</p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div class="gamePage">
              <div class="ga_skill">
                <div class="infoTitle">
                  <img src="@/assets/images/index/game_skill_title.png" alt="游戏攻略" />
                  <div class="info_title_line"></div>
                </div>
                <div class="skill_box">
                  <div class="swiper-container skill_swiper">
                    <div class="swiper-wrapper">
                      <div class="swiper-slide" v-for="(item, index) in skillList" :key="index">
                        <a :href="item.url" target="_blank">
                          <img :src="item.bigImg" class="banner" :alt="item.text" />
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="swiper-container gallery-thumbs">
                    <div class="swiper-wrapper">
                      <div class="swiper-slide" v-for="(item, index) in skillList" :key="index">
                        <img :src="item.smallImg" class="banner" :alt="item.text" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="ga_data">
                <div class="infoTitle">
                  <img src="@/assets/images/index/game_data_img.png" alt="游戏资料" />
                  <div class="info_title_line"></div>
                </div>
                <ul class="data_box">
                  <li v-for="(gtt, gti) in gameThreeDataList" :key="gti">
                    <a :href="gtt.url" target="_blank"></a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="gameCharacteristicPage">
              <div class="infoTitle">
                <img src="@/assets/images/index/game_chart_title.png" alt="游戏特色" />
                <div class="info_title_line"></div>
              </div>
              <div class="game_characteristic_box">
                <div class="video_kuang"></div>
                <div class="videoSwiperBox">
                  <swiper ref="videoSwiper" :options="swiperGameChartOptions" @slideChange="slideChange">
                    <swiper-slide v-for="(item, key) in gameChartList" :key="key">
                      <div class="game_chartVideo_mask" :class="{ moveOpact: isSwiperActive == key }">
                        <div class="gameVideoText">
                          <h3><span v-if="key == 0">【新】</span><span v-else-if="key == 1">【创】</span><span v-else-if="key == 2">【世】</span><span v-else-if="key == 3">【战】</span><span v-else-if="key == 4">【车】</span>{{ item.videoTitle }}</h3>
                          <p>{{ item.videoSubTittle }}</p>
                        </div>
                      </div>
                      <video class="tsVideo" preload="none" ref="tsVideoRef" playsinline webkit-playsinline autoplay loop="" muted="" width="100%" height="100%" :poster="item.videoPaster">
                        <source :src="item.videoSource" type="video/mp4" />
                        您的浏览器不支持video标签!
                      </video>
                    </swiper-slide>
                    <!-- 左右箭头 -->
                    <div class="swiper-button-prev" slot="button-prev"></div>
                    <div class="swiper-button-next" slot="button-next"></div>
                  </swiper>
                </div>
              </div>
            </div>
            <div class="servePage">
              <div class="serve_box ser_text">
                <div class="infoTitle">
                  <img src="@/assets/images/index/serve_title.png" alt="服务" />
                  <div class="info_title_line"></div>
                </div>
                <div class="st_box">
                  <div class="st_box_left">
                    <ul class="sixRules">
                      <li v-for="(srItem, srIndex) in sixRulesList" :key="srIndex" @click="sixClick(srItem)">
                        <a href="javascript:;"><img src="~@/assets/images/index/small_sign.png" :alt="srItem.title" />{{ srItem.title }}</a>
                      </li>
                    </ul>
                    <div class="two_erweima">
                      <div class="weChatAndDouYin" v-for="(ert, eri) in erList" :key="eri">
                        <div class="erweimaimg">
                          <img :src="ert.erweimaImg" :alt="ert.erweimaTitle" />
                        </div>
                        <p>{{ ert.erweimaTitle }}</p>
                      </div>
                    </div>
                  </div>
                  <div class="st_box_right">
                    <div class="sbr_phone">
                      <!-- <p>客服电话：</p>
                      <p>021-60371678<span style="color: #aaa; font-size: 14px">（09:00-22:00）</span></p> -->
                    </div>
                    <div class="healthyRules">
                      <p>健康游戏公告</p>
                      <ul class="hrUl">
                        <li v-for="(heaItem, heaIndex) in heaList" :key="heaIndex">
                          {{ heaItem.text }}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div class="serve_box ser_config">
                <div class="infoTitle">
                  <img src="@/assets/images/index/serve_config_title.png" alt="配置要求" />
                  <div class="info_title_line"></div>
                </div>
                <div class="sc_box">
                  <div class="configKuang">
                    <div class="configText">
                      <ul class="contentConfig" v-for="(configItem, configIndex) in configData" :key="configIndex">
                        <p>{{ configItem.configTitle }}:</p>
                        <li v-for="(cigItem, cigIndex) in configItem.configItemList" :key="cigIndex">
                          {{ cigItem.text }}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 预约提示 -->
      <div class="tip-login" v-if="tipLoginText">{{ tipLoginText }}</div>

      <!-- 右边固定小区域 -->
      <rightFixed />

      <!-- 在线客服 -->
      <div class="onlineService tac" @click="customerFun">
        <img src="@/assets/images/index/customer.png" alt="在线客服" />
      </div>

      <!-- 适龄提示弹框 -->
      <el-dialog class="year-diaLog" :visible.sync="yearsOpen" width="960px" :lock-scroll="false" :close-on-click-modal="false" @close="yearsOpen = false">
        <div class="year-diaContent">
          <p>1、本游戏是一款多人在线第三人称载具射击类游戏，适用于年满12周岁及以上的用户，建议未成年人在家长监护下使用游戏产品。</p>
          <p>2、本游戏基于架空的故事背景和科幻世界观，剧情简单且积极向上，没有基于真实历史和现实事件的改编内容。游戏中有需要多人进行配合的团队竞技，玩法基于一定难度的思维判断和肢体操作。鼓励玩家通过沟通、思考和训练达成游戏目标。游戏中有基于文字和语音的陌生人社交系统。</p>
          <p>3、本游戏中有用户实名认证系统，认证为未成年人的用户将接受以下管理： 游戏中部分玩法和道具需要付费。未满8周岁的用户无法登录游戏，不能付费；8周岁以上未满16周岁的未成年人用户，单次充值金额不得超过50元人民币，每月充值金额累计不得超过200元人民币；16周岁以上的未成年人用户，单次充值金额不得超过100元人民币，每月充值金额累计不得超过400元人民币。</p>
          <p class="infoColor">游戏仅会在周五、周六、周日和法定节假日的20时至21时，向未成年人提供1小时游戏服务。</p>
          <p>4、本游戏以多人在线战车对战为主题，有助于锻炼玩家的大脑反应速度和手眼协调能力，能够带给玩家积极愉悦的情绪体验，增强玩家的自信心。本游戏有着超多张地图和丰富的故事剧情，鼓励玩家勇于探索和挑战自我。游戏里有组队模式玩法，需要玩家互相配合，互帮互助来完成比赛，有助于培养玩家的团队协作能力。</p>
        </div>
      </el-dialog>

      <!-- video播放弹框 -->
      <el-dialog class="video-diaLog" :visible.sync="openyyvideo" width="960px" :lock-scroll="false" :close-on-click-modal="false" @close="yyvideoClose">
        <div class="video-diaContent">
          <video id="yyVideo" ref="yyVideoRef" @play="yyvideoPlay()" @pause="yyvideoPause()" autoplay loop muted="" width="100%" height="100%" preload="none" playsinline webkit-playsinline controls="" poster="">
            <source :src="yyObj.yyvideoSource" type="video/mp4" />
            您的浏览器不支持video标签!
          </video>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import headerVideoUrl from '@/assets/pageData/homeHeadeVideoUrl'
import bus from '@/utils/eventBus'
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
import Swiper1 from 'swiper'
import rightFixed from '@/components/rightFixed'
import { indexActSwiper, subscribe, isSubscribe, getIsLogin } from '@/api/index'
import { getNewsList } from '@/api/news'
import allVideosDatas from '@/assets/pageData/video_page'
import { setToken, getToken, getChannelCode, setChannelCode } from '@/utils/auth'
export default {
  name: 'index',
  components: {
    Swiper,
    SwiperSlide,
    rightFixed
  },
  directives: {
    swiper: directive
  },
  data() {
    return {
      homeVideo: headerVideoUrl.videoUrl, // 头图视频
      base_url: 'https://coapi.zhanhuo.com/',
      goYuyue: true, // 点击预约
      getReceCode: false, // 点击领取激活码
      alerayReceCode: false, // 已激活
      isWhitchBtn: 1, // 1 点击预约，2 点击领取激活码，3 已激活
      tipLoginText: '',
      openyyvideo: false,
      yyObj: {
        yyvideoPaster: 'https://statics.kongzhong.com/co/2023/04/202304110956210282.jpg',
        yyvideoSource: 'https://statics.kongzhong.com/co/2023/04/202304110956327798.mp4'
      },
      yearsOpen: false,
      lsBtnDownList: [
        {
          img: require('@/assets/images/index/ps_newGift.png'),
          url: 'https://act.zhanhuo.com/co/gift_newcomer/',
          title: '新手礼包'
        },
        {
          img: require('@/assets/images/index/ps_new.png'),
          url: 'install.html',
          title: '萌新指南'
        },
        {
          img: require('@/assets/images/index/ps_shop.png'),
          url: 'https://act.zhanhuo.com/co/pshop/',
          title: '道具商城'
        },
        {
          img: require('@/assets/images/index/ps_gift.png'),
          url: 'get_gift.html',
          title: '礼包兑换'
        }
      ],
      thList: [
        {
          url: 'actions.html',
          text1: '活动中心',
          text2: '精彩活动不容错过',
          img: require('@/assets/images/index/thimg1.png')
        },
        {
          url: 'https://co.zhanhuo.com/install.html',
          text1: '新手专区',
          text2: '快速上手指南',
          img: require('@/assets/images/index/thimg2.png')
        },
        {
          url: 'news_details.html?newsId=' + 648,
          text1: '背景故事',
          text2: '解读废土秘闻',
          img: require('@/assets/images/index/thimg3.png')
        }
      ],
      swiperActOptions: {
        loop: true,
        effect: 'fade',
        autoplay: {
          delay: 2000, //1秒切换一次
          disableOnInteraction: false,
          waitForTransition: false
        },
        observer: true,
        observeParents: false,
        on: {
          paginationRender: function () {
            const pages = document.getElementsByClassName('swiper-pagination-bullet')
            for (let i = 0; i < pages.length; i++) {
              pages[i].onmouseover = function (e) {
                e.target.click()
              }
            }
          }
        },
        pagination: {
          el: '.swiper-paginate',
          clickable: true,
          renderBullet: this.renderBullet
        }
      },
      activityBannerList: [
        // {
        //   bannerUrl: '',
        //   bannerName: '00000',
        //   bannerImage: require("@/assets/images/index/bannerTest1.jpg"),
        // },
      ],
      isIndex: 0,
      newsId: null,
      newsLoading: false,
      newsTabList: [
        {
          id: null,
          label: '综合'
        },
        {
          id: 0,
          label: '公告'
        },
        {
          id: 1,
          label: '新闻'
        },
        {
          id: 2,
          label: '活动'
        }
        // {
        //   id: 3,
        //   label: '社区'
        // }
      ],
      allNewsDataJson: [],
      isTopOneArr: [],
      zeroTopOneArr: [],
      navInContent: [],
      allVideosLists: allVideosDatas, // 视频中心数据源
      vtcur: 0,
      vibTab: [
        {
          name: '推荐视频'
        },
        {
          name: '官方视频'
        }
        // {
        //   name: '最强战车'
        // },
        // {
        //   name: '脑洞创意'
        // },
        // {
        //   name: '花式集锦'
        // },
      ],
      vibList: [],
      lvList: [
        {
          url: 'https://live.bilibili.com/p/eden/area-tags?visit_id=buhe3ecdzqo0&areaId=705&parentAreaId=2',
          img: require('@/assets/images/index/bilive.jpg'),
          text: 'B站直播专区'
        },
        {
          url: 'https://www.douyu.com/g_cszc',
          img: require('@/assets/images/index/dylive.jpg'),
          text: '斗鱼直播专区'
        },
        {
          url: 'https://www.huya.com/g/2741',
          img: require('@/assets/images/index/hylive.jpg'),
          text: '虎牙直播专区'
        },
        {
          url: 'https://www.douyin.com/user/MS4wLjABAAAAApUBa7P_p6czezF1Wltoncw_VNbWD1vNe79UKG5QWPJnKkcl82Hl0afM9gxGy_In',
          img: require('@/assets/images/index/dyinlive.jpg'),
          text: '抖音直播专区'
        }
      ],
      skillList: [
        {
          text: '攻略指南',
          url: 'https://space.bilibili.com/2097936606/channel/collectiondetail?sid=1035000',
          smallImg: require('@/assets/images/index/glsmall01.jpg'),
          bigImg: require('@/assets/images/index/glbig01.jpg')
        },
        {
          text: '精彩集锦',
          url: 'https://www.douyin.com/user/MS4wLjABAAAAApUBa7P_p6czezF1Wltoncw_VNbWD1vNe79UKG5QWPJnKkcl82Hl0afM9gxGy_In',
          smallImg: require('@/assets/images/index/glsmall02.jpg'),
          bigImg: require('@/assets/images/index/glbig02.jpg')
        },
        {
          text: '维基百科',
          url: 'https://wiki.biligame.com/crossout/%E9%A6%96%E9%A1%B5',
          smallImg: require('@/assets/images/index/glsmall03.jpg'),
          bigImg: require('@/assets/images/index/glbig03.jpg')
        }
      ],
      gameThreeDataList: [
        {
          url: 'features.html?slideIndexNum=' + 4
        },
        {
          url: 'features.html?slideIndexNum=' + 2
        },
        {
          url: 'news_details.html?newsId=' + 9
        }
      ],
      swiperGameChartOptions: {
        loop: true,
        // effect: "fade",
        autoplay: false,
        observer: true,
        observeParents: false,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      gameChartList: [
        {
          videoTitle: '画质升级 焕新体验',
          videoSubTittle: '画质全面升级 全球同步更新',
          videoPaster: require('@/assets/images/index/teseImg.jpg'),
          videoSource: 'https://coresource.zhanhuo.com/video/crossout_bj/hmsj.mp4'
        },
        {
          videoTitle: '沙盒创造 脑洞大开',
          videoSubTittle: '上千种部件拼装 打造无限可能',
          videoPaster: require('@/assets/images/index/teseImg1.jpg'),
          videoSource: 'https://coresource.zhanhuo.com/video/crossout_bj/ndfk.mp4'
        },
        {
          videoTitle: '特色阵营 14种武器类别',
          videoSubTittle: '11大阵营各具属性 解锁不同战车模组',
          videoPaster: require('@/assets/images/index/teseImg1.jpg'),
          videoSource: 'https://coresource.zhanhuo.com/video/2.16/zy.mp4'
        },
        {
          videoTitle: '多种玩法 自由选择',
          videoSubTittle: '战斗模式自由选择 30种玩法趣味十足',
          videoPaster: require('@/assets/images/index/teseImg1.jpg'),
          videoSource: 'https://coresource.zhanhuo.com/video/crossout_bj/wfqwz.mp4'
        },
        {
          videoTitle: '战车博物馆 欢乐造车',
          videoSubTittle: '一键免费试驾 成为造车达人',
          videoPaster: require('@/assets/images/index/teseImg1.jpg'),
          videoSource: 'https://coresource.zhanhuo.com/video/crossout_bj/zcbwg.mp4'
        }
      ],
      isSwiperActive: 0, // 轮播图轮播索引
      configData: [
        {
          configTitle: '最低配置',
          configItemList: [
            {
              text: '系统：WINDOWS 7／8／10／11 64BIT'
            },
            {
              text: 'CPU：四核处理器 或 以上'
            },
            {
              text: '内存：4GB'
            },
            {
              text: '显卡：A D3D11-compatible GPU'
            },
            {
              text: '硬盘空间：12GB'
            }
          ]
        },
        {
          configTitle: '推荐配置',
          configItemList: [
            {
              text: '系统：WINDOWS 7／8／10／11 64BIT'
            },
            {
              text: 'CPU：INTEL CORE i5 或 以上'
            },
            {
              text: '内存：16GB'
            },
            {
              text: '显卡：NVIDIA GEFORCE 1060 或 更高'
            },
            {
              text: '硬盘空间：20GB'
            }
          ]
        }
      ],
      sixRulesList: [
        {
          url: 'cs_center.html',
          title: '账号问题'
        },
        {
          url: 'cs_center.html',
          title: '充值问题'
        },
        {
          url: 'cs_center.html',
          title: '投诉建议'
        },
        {
          url: 'faq.html',
          title: '常见FAQ '
        },
        {
          url: 'http://kf.kongzhong.com/jianhu/index.html',
          title: '家长监护'
        },
        {
          url: 'javascript:void(0);',
          title: '在线客服'
        }
      ],
      erList: [
        {
          erweimaImg: require('@/assets/images/header/fixed_slide/gzh.jpg'),
          erweimaTitle: '官方公众号'
        },
        {
          erweimaImg: require('@/assets/images/header/fixed_slide/dy_code.png'),
          erweimaTitle: '官方抖音'
        }
      ],
      heaList: [
        {
          text: '抵制不良游戏'
        },
        {
          text: '拒绝盗版游戏'
        },
        {
          text: '注意自我保护'
        },
        {
          text: '谨防受骗上当'
        },
        {
          text: '适度游戏益脑'
        },
        {
          text: '沉迷游戏伤身'
        },
        {
          text: '合理安排时间'
        },
        {
          text: '享受健康生活'
        }
      ],
      // cnzz统计
      src: 'https://s4.cnzz.com/z_stat.php?id=1281191537',
      id: 'cnzz_stat_icon_1281191537'
    }
  },
  computed: {
    videoSwiper() {
      return this.$refs.videoSwiper.$swiper
    }
  },
  watch: {
    $route: {
      handler(to, from) {
        setTimeout(() => {
          if (window._czc) {
            const location = window.location
            const contentUrl = location.pathname + location.hash
            const refererUrl = '/'
            window._czc.push(['_setAutoPageview', false])
            window._czc.push(['_trackPageview', contentUrl, refererUrl])
          }
        }, 300)
      },
      immediate: true
    }
  },
  created() {
    this.initScrollTop()
    this.getSwiperData()
    this.getNewsData()
    this.getVideoData()
    this.getSkillData()

    bus.$on('currentUserInfo', (data) => {
      this.isSubscribeFun(data)
    })
  },
  methods: {
    // 敬请期待
    soon_downLoad() {
      // 敬请期待
      $('.tip-popup').fadeIn()
      setTimeout(function () {
        $('.tip-popup').fadeOut(3000)
      }, 1000)
    },
    // 登录
    login() {
      var obj = {
        pageType: 'pc', //web是pc html5是手机
        // loginAppid:'',//活动对应的appid，如果没有则不传此参数
        channelKey: 901, //0为默认值，表示不显示第三方渠道，901为显示
        category: 1, //0为默认点击不了 为1 登录 2注册
        sourceKey: 0, //直接登录渠道 0为战火登录 1为直接登录wegame 2小黑盒 3心游 4飞火 5顺网 6易乐玩
        gameCode: 901, //0是没有
        useNickname: 0 // 0 不显示  1 显示
      }
      initPup('up', obj)
    },
    // 判断登录的用户是否预约
    isSubscribeFun(val) {
      if (getToken()) {
        // 接口请求
        var _this = this
        $.ajax({
          type: 'get',
          dataType: 'json',
          url: _this.base_url + 'co-player-subscribe/isSubscribe',
          cache: false,
          xhrFields: {
            withCredentials: true
          },
          beforeSend: function (XMLHttpRequest) {
            XMLHttpRequest.setRequestHeader('Authorization', 'Bearer ' + val)
          },
          success: function success(res) {
            if (res.code == 0) {
              if (res.data == true) {
                _this.receiveCode(val) // 判断 是否激活
              } else if (res.data == false) {
                if (_this.getCookie('isNavLogin')) {
                  if (getChannelCode() == 'WEG') {
                    // alert('请到wegame专属预约页面预约')
                  } else {
                    _this.reserveFun()
                  }
                } else {
                  _this.isWhitchBtn = 1
                }
              }
            } else {
              _this.isWhitchBtn = 1
            }
          }
        })
      } else {
        _this.isWhitchBtn = 1
      }
    },
    // 预约按钮 三种 状态
    appointment(num) {
      window.open('https://act.zhanhuo.com/co/obtindex/', '_blank')
      // if (num == 1) {
      //   // 立即预约
      //   this.setCookie('isNavLogin', true)
      //   if (getToken()) {
      //     if (getChannelCode() == 'WEG') {
      //       // alert('请到wegame专属预约页面预约')
      //       window.open('https://www.wegame.com.cn/act/online/cszc20221031/index.html', '_blank');
      //     } else {
      //       this.reserveFun();
      //     }
      //   } else {
      //     this.login()
      //   }
      // } else if (num == 2) {
      //   // 点击获取激活码
      //   window.open('activation.html');
      // } else if (num == 3) {
      //   // 已激活
      // }
    },
    // 预约接口请求
    reserveFun() {
      subscribe().then((res) => {
        if (res.code == 0) {
          this.isWhitchBtn = 2
        } else if (res.code == 500709) {
          this.isWhitchBtn = 2
        } else if (res.code == 500200) {
          // token错误
          this.login()
        } else if (res.code == 500201) {
          // token过期
          this.login()
        } else {
          alert(res.msg)
        }
      })
    },
    // 判断用户 是否激活
    receiveCode(val) {
      var _this = this
      $.ajax({
        type: 'post',
        dataType: 'json',
        url: _this.base_url + 'co-player-subscribe/receiveCode',
        cache: false,
        xhrFields: {
          withCredentials: true
        },
        beforeSend: function (XMLHttpRequest) {
          XMLHttpRequest.setRequestHeader('Authorization', 'Bearer ' + val)
        },
        success: function success(res) {
          if (res.code == 500218) {
            // 该账号已激活
            _this.isWhitchBtn = 3
          } else if (res.code == 0) {
            // 该账户需要激活
            _this.isWhitchBtn = 2
          } else {
            _this.isWhitchBtn = 1
          }
        }
      })
    },
    // ===========

    // 预约播放视频
    yyvideoOpen() {
      var yyVideo = document.getElementById('yyVideo')
      if (yyVideo != null) {
        setTimeout(() => {
          yyVideo.play()
        }, 200)
      }
      this.openyyvideo = true
    },
    yyvideoClose() {
      var yyVideo = document.getElementById('yyVideo')
      setTimeout(() => {
        yyVideo.pause()
        // yyVideo.load();
        yyVideo.currentTime = 0
      }, 200)
      this.openyyvideo = false
    },
    // video 点击事件
    yyvideoPlay() {
      var yyVideo = document.getElementById('yyVideo')
      yyVideo.play()
    },
    yyvideoPause() {
      var yyVideo = document.getElementById('yyVideo')
      yyVideo.pause()
    },
    // 适龄提示
    cadpaClick() {
      this.yearsOpen = true
    },
    // 账号注册
    registerItem() {
      var obj = {
        pageType: 'pc', //web是pc html5是手机
        // loginAppid:'',//活动对应的appid，如果没有则不传此参数
        channelKey: 0, //0为默认值，表示不显示第三方渠道，1为显示激战2的第三方渠道，2为显示AW的第三方渠道，3为从军，4为创世战车
        category: 2, //0为默认点击不了 为1 登录 2注册
        sourceKey: 0, //直接登录渠道 0为战火登录 1为直接登录wegame 2小黑盒 3心游 4飞火 5顺网 6易乐玩
        gameCode: 901, //0是没有
        useNickname: 0 // 0 不显示  1 显示
      }
      initPup('up', obj)
    },

    // 轮播数据
    getSwiperData() {
      indexActSwiper({
        gameCode: 901,
        publishTerrace: 1,
        type: 0
      }).then((res) => {
        if (res.code == 200) {
          this.activityBannerList = res.data.bannerList // 轮播图
        }
      })
    },
    // 轮播下标
    renderBullet(index, className) {
      if (this.activityBannerList.length > 0) {
        return '<span class="' + className + '">' + this.activityBannerList[index].bannerName + '</span>'
      }
    },

    // 新闻数据
    getNewsData() {
      this.newsLoading = true
      var allNewsList = [],
        noTopDataArr = []
      getNewsList({
        gameCode: 901,
        publishTerrace: 1
      }).then((res) => {
        if (res.code == 200) {
          this.allNewsDataJson = res.data
          // 默认 综合
          allNewsList = res.data.all
          if (allNewsList.length != 0) {
            // isTop (置顶)
            for (let i = 0; i < allNewsList.length; i++) {
              if (allNewsList[i].isTop == 1) {
                // 表示置顶
                this.isTopOneArr.push(allNewsList[i])
              } else {
                // 非置顶
                noTopDataArr.push(allNewsList[i])
              }
            }

            if (this.isTopOneArr.length > 0) {
              if (noTopDataArr.length > 5) {
                this.zeroTopOneArr = noTopDataArr.slice(0, 5)
              } else {
                this.zeroTopOneArr = noTopDataArr
              }
            } else {
              if (noTopDataArr.length > 6) {
                this.zeroTopOneArr = noTopDataArr.slice(0, 6)
              } else {
                this.zeroTopOneArr = noTopDataArr
              }
            }
          }
          this.newsLoading = false
        }
      })
    },
    // 新闻tab切换
    tabClick(val, index) {
      this.newsLoading = true
      var allNewsList = [],
        noTopDataArr = []
      this.navInContent = []
      this.newsId = val.id
      this.isIndex = index

      if (this.newsId == null) {
        allNewsList = this.allNewsDataJson.all
      } else if (this.newsId == 0) {
        allNewsList = this.allNewsDataJson.announce
      } else if (this.newsId == 1) {
        allNewsList = this.allNewsDataJson.news
      } else if (this.newsId == 2) {
        allNewsList = this.allNewsDataJson.activity
      }
      // isTop (置顶)
      for (let i = 0; i < allNewsList.length; i++) {
        if (allNewsList[i].isTop == 0) {
          // 非置顶
          noTopDataArr.push(allNewsList[i])
        }
      }

      if (this.isTopOneArr.length > 0) {
        if (noTopDataArr.length > 5) {
          this.zeroTopOneArr = noTopDataArr.slice(0, 5)
        } else {
          this.zeroTopOneArr = noTopDataArr
        }
      } else {
        if (noTopDataArr.length > 6) {
          this.zeroTopOneArr = noTopDataArr.slice(0, 6)
        } else {
          this.zeroTopOneArr = noTopDataArr
        }
      }
      setTimeout(() => {
        this.newsLoading = false
      }, 200)
    },

    // 视频中心 默认数据 (推荐视频)
    getVideoData() {
      var allVideosLists = []
      allVideosLists = this.allVideosLists[0].list.reverse()
      if (allVideosLists.length > 6) {
        this.vibList = allVideosLists.slice(0, 6)
      } else {
        this.vibList = allVideosLists
      }
    },
    // 视频中心tab
    vtTabClick(index) {
      this.vtcur = index
      var allVideosLists = []
      if (index == 1) {
        // 官方视频
        allVideosLists = this.allVideosLists[index - 1].list.reverse()

        if (allVideosLists.length > 6) {
          this.vibList = allVideosLists.slice(0, 6)
        } else {
          this.vibList = allVideosLists
        }
      } else if (index == 0) {
        // 推荐视频
        this.getVideoData()
      }
    },
    viDetails(item) {
      window.open('video_details.html?videoid=' + item.id, '_blank')
    },

    // 视频轮播监听滑动事件
    slideChange() {
      // var videos = document.getElementsByClassName("tsVideo");
      // for (let i = 0; i < videos.length; i++) {
      //   setTimeout(() => {
      //     videos[i].pause();
      //     // videos[i].load();
      //     videos[i].currentTime = 0
      //   }, 150);
      // }
      // setTimeout(() => {
      //   videos[this.videoSwiper.activeIndex].play();
      // }, 200);

      // this.isSwiperActive = this.$refs.videoSwiper.$swiper.activeIndex; // 非循环用这个
      this.isSwiperActive = this.$refs.videoSwiper.$swiper.realIndex // 循环用这个
    },

    // 游戏攻略
    getSkillData() {
      this.$nextTick(() => {
        var galleryThumbs = new Swiper1('.gallery-thumbs', {
          spaceBetween: 10,
          slidesPerView: 3,
          freeMode: true,
          grabCursor: true, // 抓手
          watchSlidesVisibility: true,
          watchSlidesProgress: true
        })
        var galleryTop = new Swiper1('.skill_swiper', {
          spaceBetween: 10,
          thumbs: {
            swiper: galleryThumbs
          }
        })
      })
    },
    // 精彩直播
    lvClick(item) {
      window.open(item.url)
    },

    sixClick(item) {
      if (item.title == '在线客服') {
        this.customerFun()
        return
      } else if (item.title == '家长监护') {
        window.open(item.url)
        return
      }
      location.href = item.url
    },

    // 在线客服
    customerFun() {
      showTypeCustomer()
    },

    // 页面滚动到指定div加class
    initScrollTop() {
      var obj = ['videoPage', 'gamePage', 'servePage', 'gameCharacteristicPage'],
        l = 0
      for (var i = l; i < obj.length; i++) {
        var element = $('.' + obj[i])
        element.removeClass('pageTransform')
      }
    },
    pageIndexScroll() {
      var obj = ['videoPage', 'gamePage', 'servePage', 'gameCharacteristicPage'],
        l = 0
      for (var i = l; i < obj.length; i++) {
        var element = $('.' + obj[i])
        if (element.offset().top < parseInt($(window).height()) + parseInt($(window).scrollTop()) + 50) {
          if (!element.hasClass('pageTransform')) {
            element.addClass('pageTransform')
          }
        }
      }
    },

    // cnzz统计
    initCNZZ() {
      //添加脚本
      const script = document.createElement('script')
      script.src = this.src
      script.id = this.id
      script.language = 'JavaScript'
      document.body.appendChild(script)
    }
  },
  mounted() {
    this.initCNZZ()
    window.addEventListener('scroll', this.pageIndexScroll)
  },
  beforeDestroy: function () {
    window.removeEventListener('scroll', this.pageIndexScroll)
    bus.$off('currentUserInfo')
  }
}
</script>
<style lang="scss" scoped>
@import '~@/styles/index.scss';
</style>
